import { useMutation } from '@tanstack/react-query';

import { marketplaceApi } from '../api/marketplaceApi';
import type { BannerUploadImageItem } from '../utils/buildBannerImageUploadItems';

interface UploadBannerImagesPayload {
  bannerId: number;
  images: BannerUploadImageItem[];
}

interface UploadBannerImagesResult {
  failedUploads: {
    item: BannerUploadImageItem;
    error: unknown;
  }[];
}

export function useBannerImageUpload() {
  const { mutateAsync: uploadBannerImages, isPending: isUploading } =
    useMutation({
      mutationFn: async (
        payload: UploadBannerImagesPayload
      ): Promise<UploadBannerImagesResult> => {
        const failedUploads: UploadBannerImagesResult['failedUploads'] = [];

        for (const image of payload.images) {
          try {
            await marketplaceApi.uploadBannerImage(
              payload.bannerId,
              image.uploadKey,
              image.file
            );
          } catch (error) {
            failedUploads.push({ item: image, error });
          }
        }

        return { failedUploads };
      },
    });

  return {
    uploadBannerImages,
    isUploading,
  };
}
